export const ADD_EVALUATION_EVENT_REQUEST = "ADD_EVALUATION_EVENT_REQUEST";

export const VIEW_FORM_REQUEST = "VIEW_FORM_REQUEST";
export const VIEW_FORM_RESPONSE = "VIEW_FORM_RESPONSE";

export const SUBMIT_EVALUATION_EVENT_REQUEST =
  "SUBMIT_EVALUATION_EVENT_REQUEST";

export const GET_EVALUATION_REQUEST = "GET_EVALUATION_REQUEST";
export const GET_EVALUATION_RESPONSE = "GET_EVALUATION_RESPONSE";

export const UPDATE_EVALUATION_REQUEST = "UPDATE_EVALUATION_REQUEST";
export const UPDATE_EVALUATION_RESPONSE = "UPDATE_EVALUATION_RESPONSE";
